export const STAGING_DOMAIN = "https://www-staging.guideline.io";
export const PRODUCTION_DOMAIN = "https://www.guideline.com";
export const LOCAL_DOMAIN = "http://localhost:3000";

export const LOCAL_DOMAIN_PROXY = "http://localhost:4001";
export const LOCAL_API_DOMAIN = "http://localhost:4000";
export const STAGING_API_DOMAIN = "https://my-staging.guideline.io";
export const PRODUCTION_API_DOMAIN = "https://my.guideline.com";

export const CMS_ASSETS_DOMAIN = "https://cms-assets.guideline.com";

// App endpoints
export const FUNDS_PATH = "/api/v1/cors/funds.json";
export const PORTFOLIO_TEMPLATES_PATH = "/api/v1/cors/dc_portfolio_templates.json";
export const PUBLIC_FEATURES_PATH = "/api/v1/cors/public_features.json";

export const HEADER_MENU_CLOSE_DELAY = 650;
export const HEADER_DESKTOP_HEIGHT = 72;
export const HEADER_DESKTOP_SCROLL_HEIGHT = 64;
export const HEIGHT_WITHOUT_HEADER_IF_NO_TOP_COMPONENT = 700;
export const HEADER_TRANSITION_DURATION = "0.3s";
export const DESKTOP_BANNER_HEIGHT = 56;
export const MOBILE_BANNER_HEIGHT = 64;

export const GFA_SCHEDULE_DEMO_TOKEN = "gfa-schedule-demo";
export const SCHEDULE_DEMO_TOKEN = "schedule-demo";
export const EVENT_TYPE_ACCOUNTANT = "accountants";
export const EVENT_TYPE_ADVISOR = "advisors";
export const EVENT_TYPE_DEMO = "demo"; // For "Schedule a demo" forms

export const PIPELINE_SLUGS = ["/pipeline", "/gfa-pipeline"];

export const PIPELINE_SCHEDULE_TOKENS: Record<string, string> = {
  "/gfa-pipeline/basic": GFA_SCHEDULE_DEMO_TOKEN,
  "/pipeline/basic": SCHEDULE_DEMO_TOKEN,
};

// slugs that should not use prefetching
// these will also redirect using window.location.href strategy
// instead of router push calls
export const BLOCKED_PREFETCH_SLUGS = [...PIPELINE_SLUGS, "/integrations/connect", "/blog", "/helpcenter"];

// top-of-funnel GFA entry points by URL path
export const GFA_DATA_MAP = {
  "/accountants": {
    event_type: "accountants",
    sales_plan_type: "401k_accountants",
    source: null,
    role: "accountant_bookkeeper",
  },
  "/advisors": {
    event_type: "advisors",
    role: null,
    sales_plan_type: "401k_advisors",
    source: null,
  },
  "/benefitsprofessionals": {
    event_type: "benefits_professionals",
    role: "benefits_professional",
    sales_plan_type: "401k_accountants",
    source: null,
  },
  "/partner": {
    event_type: "advisors",
    role: null,
    sales_plan_type: "401k_advisors",
    source: null,
  },
  "/pro": {
    event_type: "advisors",
    role: null,
    sales_plan_type: "401k_advisors",
    source: null,
  },
};

export const PREV_MODE_STORAGE_KEY = "prevModeToken";

interface MappedPath {
  path: RegExp | string;
  source: string;
}

export const PATH_TO_SOURCE_MAPPINGS: MappedPath[] = [
  { path: "/welcome", source: "homepage/welcome" },
  { path: "/401k", source: "401k/demo/cards" },
  { path: "/company", source: "company/demo/cards" },
  { path: "/", source: "homepage/demo/cards" },
  { path: "/integrations", source: "integrations/demo/cards" },
  { path: "/investments", source: "investments/demo/cards" },
  { path: "/pricing", source: "pricing/demo/cards" },
  { path: "/statemandates", source: "state mandate" },
  { path: /^\/partners\/signup-([^/]+)/, source: "$1" },
  { path: /^\/partners\/([^/]+)/, source: "$1" },
  { path: /^\/california\/partners\/([^/]+)/, source: "california $1" },
  { path: /^\/statemandates\/partners\/([^/]+)/, source: "state mandate $1" },
];
